<template>
  <div class="championships">
    <va-card :title="$t('championships.cards.title')">
      <va-list fit>
        <vue-nestable
          v-model="championships"
          :maxDepth='1'
          keyProp='order'
        >
          <template
            slot-scope="{ item, index }"
          >
            <va-item>
              <va-item-section>
                <vue-nestable-handle
                  :item="item"
                >
                  <va-item-label>
                    {{ item.name }}
                  </va-item-label>
                </vue-nestable-handle>
              </va-item-section>
              <va-item-section side>
                {{index + 1}}
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < championships.length - 1"/>
          </template>
        </vue-nestable>
      </va-list>
      <va-button
        @click='salvar'
      >
        Salvar
      </va-button>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { VueNestable, VueNestableHandle } from 'vue-nestable'
import 'vue-nestable/example/assets/vue-nestable.css'

export default {
  name: 'championships',
  components: {
    VueNestable,
    VueNestableHandle,
  },
  methods: {
    salvar () {
      const self = this
      const vars = []
      let mutations = ''
      const values = {}
      this.championships.forEach((element, i) => {
        const i1 = i + 1
        vars.push(`$order${i1}: Int, $id${i1}: Int!`)
        mutations += `
        up${i1}: update_championship_by_pk(pk_columns: {id: $id${i1}}, _set: {order: $order${i1}}) {
          id
        }
        `
        values[`id${i1}`] = element.id
        values[`order${i1}`] = i1
      })
      this.$apollo
        .mutate({
          mutation:
            gql`
              mutation MyMutation(${vars.join(',')}) {
                ${mutations}
              }
              `,
          variables: values,
        })
        .then(_ => {
          self.showToast(
            self.$t(
              'toasts.successUpdate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
          this.$apollo.queries.championships.refetch()
        })
        .catch(_ => {
          self.showToast(
            self.$t(
              'toasts.errorUpdate',
            ),
            {
              icon: 'fa-check',
              position: 'top-right',
              duration: 1000,
              fullWidth: false,
            },
          )
        })
    },
  },
  data () {
    return {
      championships: [],
    }
  },
  apollo: {
    championships: {
      query: gql`
      query MyQuery {
        championships: championship(order_by: {order: asc}, where: {id_api: {_is_null: false}}) {
          id
          name
          order
        }
      }
      `,
      result ({ data, loading }) {
        if (!loading) {
          data.championships.forEach((element, i) => {
            element.order = i
          })
        }
      },
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('championships')) {
      this.$apollo.queries.championships.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
